import { render, staticRenderFns } from "./TraktApp.vue?vue&type=template&id=08d02893&"
import script from "./TraktApp.vue?vue&type=script&lang=js&"
export * from "./TraktApp.vue?vue&type=script&lang=js&"
import style0 from "./TraktApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports